export default __webpack_public_path__ + "static/media/car2.4231ff60.png";